/** Event registration question labels — API values stay English; labelKeys map to i18n JSON. */

/** Values sent to the API unchanged; labelKey is for display only. */
export const EVENT_STAGE_OPTIONS = [
  { value: "Early Stage", labelKey: "events.stage.earlyStage" },
  { value: "Growth", labelKey: "events.stage.growth" },
  { value: "Established", labelKey: "events.stage.established" },
  { value: "Executive", labelKey: "events.stage.executive" },
] as const;

export const EVENT_OBJECTIVES_OPTIONS = [
  { value: "B2B Lead generation", labelKey: "events.objectives.b2bLeadGeneration" },
  { value: "Finding reliable B2B services", labelKey: "events.objectives.findingB2bServices" },
  {
    value: "Getting mentorship/advice from experienced business owners",
    labelKey: "events.objectives.mentorshipAdvice",
  },
  {
    value: "Supporting growing Muslim businesses",
    labelKey: "events.objectives.supportingMuslimBusinesses",
  },
  {
    value: "Finding potential investment opportunities",
    labelKey: "events.objectives.investmentOpportunities",
  },
  { value: "Meeting potential investors", labelKey: "events.objectives.meetingInvestors" },
  {
    value: "Meeting online connections in person",
    labelKey: "events.objectives.meetingOnlineConnections",
  },
  {
    value: "Learning more about SMBF / SMBF Services",
    labelKey: "events.objectives.learningSmbf",
  },
  { value: "General networking", labelKey: "events.objectives.generalNetworking" },
  {
    value: "Exploring business partnerships",
    labelKey: "events.objectives.exploringPartnerships",
  },
  { value: "Other", labelKey: "events.objectives.other" },
] as const;

export {
  SECTOR_OPTIONS as EVENT_SECTOR_OPTIONS,
  OTHER_SECTOR_VALUE as EVENT_OTHER_SECTOR_VALUE,
  getSectorDisplayLabel as getEventSectorDisplayLabel,
} from "../utils/sectors";

type TranslateFn = (key: string) => string;

/** Map stored English API value → localized display label; unknown values pass through. */
export function getEventObjectiveDisplayLabel(
  value: string | null | undefined,
  t: TranslateFn,
): string {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";
  const opt = EVENT_OBJECTIVES_OPTIONS.find((o) => o.value === trimmed);
  return opt ? t(opt.labelKey) : trimmed;
}

export function getEventStageDisplayLabel(
  value: string | null | undefined,
  t: TranslateFn,
): string {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";
  const opt = EVENT_STAGE_OPTIONS.find((o) => o.value === trimmed);
  return opt ? t(opt.labelKey) : trimmed;
}
